/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ReCAPTCHA from "react-google-recaptcha";
import { ISOTPPASSWORD, OTPVia, SHOWSIGNUPREFERENCENAME, SHOWSIGNUPREFERENCENAMECOMPULSORY } from '../../configs/authSignupConfig';
import * as authServices from '../../services/authService';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID, ReCAPTCHA_KEY } from '../../configs/const';
import * as accountServices from '../../services/accountService';
import { SOCIALMEDIALINKS } from '../../configs/apkFileName';
import { PotanuCaptcha } from '../../configs/casinoShowList';
const recaptchaRef = React.createRef();
let sendotpinterval;
class Joinnowpopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            personName: "",
            usernamesignup: "",
            usernamealreadyexist: false,
            passwordsignup: "",
            passwordsignup_confirm: "",
            mobileNumber: "",
            otpsignup: "",
            mobilealreadyexist: false,
            mobilealreadyexistchecked: false,
            mobileNumberCountryCode: "",
            mobileNumberisValid: false,
            whatsUpNumber: "",
            whatsUpNumberisValid: false,
            sameAsMobile: true,
            emailsignup: "",
            passVisible: false,
            confirmPassVisible: false,
            tncChecked: true,
            buttonLoader: false,
            otpSent: 0,
            otpSentTo: '',
            resendOtp: 0,
            isSignUpReferenceName: true,
            signUpReferenceName: ''
        };
    }
    componentDidMount() {
        if (!!this.props.affCode) {
            this.setState({ signUpReferenceName: this.props.affCode })
        } else {
            if (SHOWSIGNUPREFERENCENAME && this.state.isSignUpReferenceName) {
                const affCd = sessionStorage.getItem('affcode');
                if(!!affCd){
                    this.setState({ signUpReferenceName: affCd });
                }
            }
        }
    }

    componentWillUnmount() {
        clearInterval(sendotpinterval);
    }

    submitForm() {
        const self = this;
        // if (recaptchaRef.current.getValue() === '') {
        //     this.props.notify("Attend Captcha", "warning")
        // } else {
            // "password" : this.state.passwordsignup,
            // "name":this.state.personName,
            // "operatorId":"",

            if(this.validateForSubmit()){
                return false;
            }


            let body = {
                "username": this.state.usernamesignup.trim().toLowerCase(),
                "mobile": this.state.mobileNumber,
                "password": this.state.passwordsignup,
                "whatsappMobile": this.state.mobileNumber//this.state.sameAsMobile ? this.state.mobileNumber : this.state.whatsUpNumber
            }
            if(OTPVia==='email'){
                body["email"] = this.state.emailsignup;
                body['registerBy'] = "MAIL";
            }

            if (ISOTPPASSWORD) {
                body["otp"] = this.state.otpsignup;
            }

            if (SHOWSIGNUPREFERENCENAME && this.state.isSignUpReferenceName) {
                body["referenceName"] = this.state.signUpReferenceName.toUpperCase();
            }

            this.setState({ buttonLoader: true }, () => {
                authServices.RegisterNewWithOtp(body).then(async (result) => {
                    self.setState({ buttonLoader: false });
                    if (result.isSuccess) {
                        self.props.notify("Registered successfully!", "success");
                        if (OPERATOR_ID === 'RDR' && window.location.origin === 'https://www.1xbook.com') {
                            window.sprtRdrCommonFunction("track.user.registration", { action: "complete", userId: self.state.usernamesignup });
                        }
                        // let body = {
                        //     "username": self.state.usernamesignup.trim().toLowerCase(),
                        //     "password": self.state.passwordsignup,
                        // }
                        // self.signInApi(body);
                        sessionStorage.removeItem('affcode');
                        self.props.hidePopup();
                        document.getElementById('btnLoginb2cLogin').click();
                        self.props.showSweetAlert({
                            icon: 'success',
                            title: 'Thanks for signing up.',
                            html: 'Confirmed! You’re in! Please login',
                            //text: 'Confirmed! You’re in!,Please login.',
                            footer: 'We are glad that you joined us.'
                        })


                    } else {
                        self.props.notify(result.exception.message, "error")
                    }
                })
            })
        // }
    }
    // jointest(){
    //     this.props.showSweetAlert({
    //         icon: 'success',
    //         title: 'Request sent',
    //         html: 'New password has been sent to your registered mobile number. Use 6 digit code as password for login.<br><hr>आपके पंजीकृत मोबाइल नंबर पर नया पासवर्ड भेज दिया गया है। लॉगिन के लिए पासवर्ड के रूप में 6 अंकों के कोड का प्रयोग करें।',
    //         //text: 'Confirmed! You’re in!,Please login.',
    //         // footer: 'We are glad that you joined us.'
    //       })
    // }

    checkIfUserExists() {
        const self = this;
        if (this.state.usernamesignup !== '' && this.state.usernamesignup.length > 5)
            authServices.checkIfUserExists(this.state.usernamesignup).then(async (result) => {
                self.setState({ usernamealreadyexist: result ? false : true }, () => {
                    if (OPERATOR_ID === 'RDR' && window.location.origin === 'https://www.1xbook.com' && !self.state.usernamealreadyexist) {
                        window.sprtRdrCommonFunction("track.user.registration", { action: "start" });
                    }
                })
            })
    }

    checkIfMobileExists() {
        const self = this;
        if (this.state.mobileNumber !== '' && this.state.mobileNumberisValid) {
            authServices.checkIfMobileExists(this.state.mobileNumber).then(async (result) => {
                self.setState({ mobilealreadyexist: result ? false : true, mobilealreadyexistchecked: true })


            })
        }
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }
    onUserChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        value = value.replace(/[^A-Za-z0-9]/g, '');
        this.setState({ [name]: value })
    }

    validateForSubmit(onlyForMobile = false) {
        // return this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm || this.state.mobileNumber === "" || this.state.mobilealreadyexist || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())) || !this.state.tncChecked || this.state.usernamealreadyexist
        // return this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || this.state.mobileNumber === "" || this.state.mobilealreadyexist || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())) || !this.state.tncChecked || this.state.usernamealreadyexist
        // console.log(this.state.otpSent === 0 || this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || ( ISOTPPASSWORD === true ? (this.state.otpsignup === "" || this.state.otpsignup.length !== 6) : false) || (this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm) || this.state.mobileNumber === "" || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || !this.state.tncChecked || this.state.usernamealreadyexist);
        // console.log(this.state.otpSent === 0 || this.state.usernamesignup === "" || this.state.usernamesignup.length < 6 || ( ISOTPPASSWORD === true ? (this.state.otpsignup === "" || this.state.otpsignup.length !== 6) : false) || (this.state.passwordsignup === "" || this.state.passwordsignup_confirm === "" || !(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g)) || this.state.passwordsignup.length < 8 || this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 || this.state.passwordsignup !== this.state.passwordsignup_confirm) || this.state.mobileNumber === "" || !this.state.mobileNumberisValid || (!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) || !this.state.tncChecked || this.state.usernamealreadyexist)
        if (onlyForMobile) {
            return OTPVia === 'mobile' ? (this.state.mobileNumber === "" || !this.state.mobileNumberisValid) : (this.state.emailsignup === "" || !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim())))
        } else {
            if(OTPVia === 'mobile'){
                if(this.state.mobileNumber === "" ){
                    this.props.notify(`Enter mobile number.`, "error");
                    return true;
                }
                if(!this.state.mobileNumberisValid ){
                    this.props.notify(`Enter valid mobile number.`, "error");
                    return true;
                }
            } else {
                if(this.state.emailsignup === "" ){
                    this.props.notify(`Enter Email.`, "error");
                    return true;
                }
                if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim()))){
                    this.props.notify(`Enter valid Email.`, "error");
                    return true;
                }
                if(this.state.mobileNumber !== "" && !this.state.mobileNumberisValid ){
                    this.props.notify(`Enter valid mobile number.`, "error");
                    return true;
                }
            }
            if(ISOTPPASSWORD === true ? this.state.otpSent === 0 : false ){
                this.props.notify(`Click Get Code button in order to receive OTP.`, "error");
                return true;
            }
            if(this.state.usernamesignup === "" ){
                this.props.notify(`Enter username.`, "error");
                return true;
            }
            if(this.state.usernamesignup.length < 6 ){
                this.props.notify(`Username should be atleast 6 characters.`, "error");
                return true;
            }
            const rgx = /^[A-Za-z1-9][A-Za-z0-9]*$/;
            if(!rgx.test(this.state.usernamesignup)){
                this.props.notify(`Username cannot start with zero.`, "error");
                return true;
            }
            if(this.state.usernamealreadyexist ){
                this.props.notify(`Username already exsist please other username.`, "error");
                return true;
            }
            if((ISOTPPASSWORD === true ? (this.state.otpsignup === "" || this.state.otpsignup.length !== 6) : false) ){
                this.props.notify(`Provide valid OTP.`, "error");
                return true;
            }
            if(this.state.passwordsignup === ""){
                this.props.notify(`Enter Password.`, "error");
                return true;
            }
            if(this.state.passwordsignup_confirm === ""){
                this.props.notify(`Enter confirm Password.`, "error");
                return true;
            }
            
            if(!(this.state.passwordsignup.match(/[0-9]/g)) || !(this.state.passwordsignup.match(/[a-zA-Z]/g))) {
                this.props.notify(`Password should be AlphaNumeric.`, "error");
                return true;
            }
            if(this.state.passwordsignup.length < 8 ){
                this.props.notify(`Password should be aleast 8 characters.`, "error");
                return true;
            }
            if(this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 ){
                this.props.notify(`Password cannot contain username.`, "error");
                return true;
            }
            if(this.state.passwordsignup !== this.state.passwordsignup_confirm){
                this.props.notify(`Password mismatch.`, "error");
                return true;
            }
            
            // if((!this.state.sameAsMobile && (this.state.whatsUpNumber === "" || !this.state.whatsUpNumberisValid)) ){
            //     this.props.notify(`Enter whatsapp mobile number`, "error");
            //     return true;
            // }
            // if(!this.state.tncChecked ){
            //     this.props.notify(`Click onto T&C.`, "error");
            //     return true;
            // }
            if((SHOWSIGNUPREFERENCENAMECOMPULSORY ? this.state.signUpReferenceName === "" : false)){
                this.props.notify(`Provide valid reference code`, "error");
                return true;
            }

            return false
        }
        //return false;
    }

    checkPhoneNumberValidity(countryCode, value) {
        const phonesregex = {
            'AM': /^(\+?374|0)((10|[9|7][0-9])\d{6}$|[2-4]\d{7}$)/,
            'AE': /^((\+?971)|0)?5[024568]\d{7}$/,
			'AZ': /^\+?[1-9]{1}[0-9]{3,14}$/,
            'BH': /^(\+?973)?(3|6)\d{7}$/,
            'DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
            'EG': /^((\+?20)|0)?1[0125]\d{8}$/,
            'IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
            'JO': /^(\+?962|0)?7[789]\d{7}$/,
            'KW': /^(\+?965)[569]\d{7}$/,
            'SA': /^(!?(\+?966)|0)?5\d{8}$/,
            'SY': /^(!?(\+?963)|0)?9\d{8}$/,
            'TN': /^(\+?216)?[2459]\d{7}$/,
            'BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
            'BG': /^(\+?359|0)?8[789]\d{7}$/,
            'BD': /^(\+?880|0)1[13456789][0-9]{8}$/,
            'CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
            'DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
            'DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
            'AT': /^(\+43|0)\d{1,4}\d{3,12}$/,
            'GR': /^(\+?30|0)?(69\d{8})$/,
            'AU': /^(\+?61|0)4\d{8}$/,
            'GB': /^(\+?44|0)7\d{9}$/,
            'GG': /^(\+?44|0)1481\d{6}$/,
            'GH': /^(\+?233|0)(20|50|24|54|55|59|25|27|57|26|56|23|28)\d{7}$/,
            'HK': /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
            'MO': /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
            'IE': /^(\+?353|0)8[356789]\d{7}$/,
            'IN': /^(\+?91|0)?[6789]\d{9}$/,
            'KE': /^(\+?254|0)(7|1)\d{8}$/,
            'MT': /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
            'MU': /^(\+?230|0)?\d{8}$/,
            'NG': /^(\+?234|0)?[789]\d{9}$/,
            'NZ': /^(\+?64|0)[28]\d{7,9}$/,
            'PK': /^((\+?92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
            'RW': /^(\+?250|0)?[7]\d{8}$/,
            'SG': /^(\+65)?[89]\d{7}$/,
            'SL': /^(?:0|94|\+94)?(7(0|1|2|5|6|7|8)( |-)?\d)\d{6}$/,
            'TZ': /^(\+?255|0)?[67]\d{8}$/,
            'UG': /^(\+?256|0)?[7]\d{8}$/,
            'US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
            'ZA': /^(\+?27|0)\d{9}$/,
            'ZM': /^(\+?26)?09[567]\d{7}$/,
            'CL': /^(\+?56|0)[2-9]\d{1}\d{7}$/,
            'EC': /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
            'ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
            'MX': /^(\+?52)?(1|01)?\d{10,11}$/,
            'PA': /^(\+?507)\d{7,8}$/,
            'PY': /^(\+?595|0)9[9876]\d{7}$/,
            'UY': /^(\+598|0)9[1-9][\d]{6}$/,
            'EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
            'IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
            'FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
            'FJ': /^(\+?679)?\s?\d{3}\s?\d{4}$/,
            'FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
            'FR': /^(\+?33|0)[67]\d{8}$/,
            'GF': /^(\+?594|0|00594)[67]\d{8}$/,
            'GP': /^(\+?590|0|00590)[67]\d{8}$/,
            'MQ': /^(\+?596|0|00596)[67]\d{8}$/,
            'RE': /^(\+?262|0|00262)[67]\d{8}$/,
            'IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
            'HU': /^(\+?36)(20|30|70)\d{7}$/,
            'ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
            'IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
            'JP': /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
            'KZ': /^(\+?7|8)?7\d{9}$/,
            'GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
            'KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
            'LT': /^(\+370|8)\d{8}$/,
            'MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
            'NO': /^(\+?47)?[49]\d{7}$/,
            'NP': /^(\+?977)?9[78]\d{8}$/,
            'BE': /^(\+?32|0)4?\d{8}$/,
            'NL': /^(\+?31|0)6?\d{8}$/,
            'PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
            'BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
            'PT': /^(\+?351)?9[1236]\d{7}$/,
            'RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
            'RU': /^(\+?7|8)?9\d{9}$/,
            'SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
            'SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
            'RS': /^(\+3816|06)[- \d]{5,9}$/,
            'SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
            'TH': /^(\+66|66|0)\d{9}$/,
            'TR': /^(\+?90|0)?5\d{9}$/,
            'UA': /^(\+?38|8)?0\d{9}$/,
            'VN': /^(\+?84|0)((3([2-9]))|(5([2689]))|(7([0|6-9]))|(8([1-6|89]))|(9([0-9])))([0-9]{7})$/,
            'CN': /^((\+|00)86)?1([358][0-9]|4[579]|6[67]|7[01235678]|9[189])[0-9]{8}$/,
            'TW': /^(\+?886\-?|0)?9\d{8}$/,
            'GE': /^(\+?995\-?|0)?[3457]\d{8}$|[3457]\d{9}$/,
            'LK': /^(?:7|0|(?:94))[0-9]{9,10}$/
        };
        let valid = false;

        const countryRegex = phonesregex[countryCode];
        if (!!countryRegex) {
            valid = countryRegex.test(value);
        }

        return valid;
    }

    onPhoneNumberChange(inputNumber, country, name) {
        // mobilealreadyexistchecked
        this.setState({ [name]: inputNumber, [`${name}CountryCode`]: country.countryCode.toUpperCase(), [`${name}isValid`]: this.checkPhoneNumberValidity(country.countryCode.toUpperCase(), inputNumber) }, () => {
            if (OTPVia === 'mobile' && name === "mobileNumber" && this.state.otpSent > 0 && this.state.mobileNumber !== this.state.otpSentTo) {
                clearInterval(sendotpinterval);
                this.setState({ otpSent: 0, otpSentTo: "", resendOtp: 0, usernamesignup: "", usernamealreadyexist: false, passwordsignup: "", passwordsignup_confirm: "", otpsignup: "", mobileNumberCountryCode: "", mobileNumberisValid: false, whatsUpNumber: "", whatsUpNumberisValid: false, sameAsMobile: false, passVisible: false, confirmPassVisible: false, tncChecked: false });
            }
        });
    }

    onPasswodVisible() {
        if (!!this.state.passVisible) {
            document.getElementById("passwordsignup").type = "Password"
        } else {
            document.getElementById("passwordsignup").type = "text"
        }
        this.setState({ passVisible: !this.state.passVisible })
    }
    onConfirmPasswodVisible() {
        if (!!this.state.confirmPassVisible) {
            document.getElementById("passwordsignup_confirm").type = "Password"
        } else {
            document.getElementById("passwordsignup_confirm").type = "text"
        }
        this.setState({ confirmPassVisible: !this.state.confirmPassVisible })
    }

    sendOTP(resend = false) {
        const self = this;
        if (!this.validateForSubmit(true)) {
            const body = {
                'username': '',
                'isSignupPage': true,
                'isResend': resend
            }
            if(OTPVia === 'mobile'){
                body['mobile'] = this.state.mobileNumber;
            } else {
                body['email'] = this.state.emailsignup;
            }
            authServices.sendOTP(body).then(async (result) => {
                if (!!result && !!result.isSuccess && result.isSuccess) {
                    const otpSent = self.state.otpSent + 1;
                    self.setState({ otpSent: otpSent, otpSentTo: self.state.mobileNumber, resendOtp: 60 }, () => {
                        self.sendOtpIntervalStart();
                    });
                } else {
                    self.props.notify(result.exception.message, 'error');
                }
            })
        }
    }

    sendOtpIntervalStart() {
        const self = this;
        sendotpinterval = setInterval(async function sendotpintervalagain() {
            clearInterval(sendotpinterval)
            if (self.state.resendOtp > 0) {
                // debugger
                const resendOtp = self.state.resendOtp - 1;
                self.setState({ resendOtp: resendOtp }, () => {
                    sendotpinterval = setInterval(sendotpintervalagain, 1000)
                    return false
                });
            }
        }, 1000)
    }
    signInApi(body) {
        const self = this;
        this.setState({ buttonLoader: true }, () => {
            authServices.signin(body).then(async (result) => {
                if (result.token) {
                    let data = {
                        token: result.token
                    }
                    let accessControl = {
                        sports: true,
                        binary: true,
                        casino: true
                    }
                    localStorage.setItem("userAuthDetail", JSON.stringify(data))
                    let velidateData = await authServices.velidateToken()

                    if (!!velidateData.role && velidateData.role === "Client") {
                        localStorage.setItem("tokenData", JSON.stringify(velidateData))
                        localStorage.setItem("accessControl", JSON.stringify(accessControl))
                        let accData = await accountServices.getAccountData()
                        if (!!accData && !!accData.userLock && accData.userLock) {
                            self.props.notify("User Is Locked. Please Contact Upperline!", "error")
                            self.logout()
                        }
                        localStorage.setItem("accountData", JSON.stringify(accData))
                        let configData = await authServices.getConfigButton()
                        localStorage.setItem("buttonsValues", JSON.stringify(configData))
                        if (velidateData.pwdch) {
                            self.setState({ buttonLoader: false });
                            self.setState({ setPassword: true }, () => {
                                document.getElementById('setpwdoldpasscode').focus();
                            });
                        }
                        else {
                            self.setState({ buttonLoader: false });
                            window.location.reload();
                        }
                    } else if (!!velidateData.role && velidateData.role !== "Client") {
                        self.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
                    } else {
                        self.props.notify(velidateData.exception.message, "error")
                    }
                } else {
                    self.setState({ buttonLoader: false });
                    self.props.notify(result.exception.message, "error")
                }
            })
        })
    }

    render() {
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (
            <>
                <div id="marketbetspopup" className="modal fade show sign-up-form sign-up-form-new" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                    <div className="modal-dialog  modal-dialog-scrollable modal-sm" >
                        <div className="modal-content ">
                            <div className="modal-body p-0" id='content'>
                                <button onClick={() => { this.props.hidePopup() }} type="button" className="close text-black closearrow" data-dismiss="modal" aria-hidden="true">×</button>
                                {/* <img style={{ width: "100%", borderRadius: "10px", marginBottom: "10px" }} src={BASE_IMAGE_PATH + "/casino/banner/images/signup-popup.webp"} alt={""}></img> */}
                                <img style={{ width: "100%", borderRadius: "10px", marginBottom: "10px" }} src={`${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/uimg/signup-popup.webp`} alt={""}></img>
                                <h5 className="modal-title mt-0 text-black text-center f11" id="myModalLabel">Register as New User</h5>
                                <div className='getid'>Get your instant ID from whatsapp</div>
                                <div>
                                    <div className="signUpNew_whattsUp_button btn-grad"><a href={(SclMd?.SOCIALMEDIALINKS?.whatsapp?.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp?.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} target="_blank" className="whatsapp-text">
                                        <div className="signUpNew_whattsUp_button-icon"><img src='https://images.staticcontent.io/casino/banner/images/whatsapp-icon-new.png'></img></div>
                                        <div className="signUpNew_whattsUp_button-number blinking">WHATSAPP NOW</div></a>
                                    </div>
                                </div>
                                <div className="signUpNew-separator">
                                    <div className="signUpNew-separator-rightLine"></div>
                                    <div className="signUpNew-separator-or">OR</div>
                                    <div className="signUpNew-separator-leftLine"></div>
                                </div>
                                <div action="">
                                    {OTPVia === 'mobile' ? 
                                        <div className='mb-1 mt-2 p-relative'>
                                            <label htmlFor="mobileNumber" className="uname" data-icon="u">Mobile <span className='star'>*</span></label>
                                            <PhoneInput specialLabel="" country={'in'} value={this.state.mobileNumber} name="mobileNumber" onChange={(inputNumber, country) => { this.onPhoneNumberChange(inputNumber, country, 'mobileNumber') }} placeholder="Enter Mobile Number" />
                                            {this.state.mobileNumber !== "" && this.state.mobilealreadyexist ? <label id='mobilealreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This mobile number already exists.</label> : null}

                                            <button className='btn-type-submit otpbtnnew' disabled={this.validateForSubmit(true)} onClick={() => { this.sendOTP() }}>
                                                {this.state.buttonLoader &&
                                                    <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                                    </svg>}
                                                Get Code
                                            </button>
                                        </div>
                                        :
                                        <div className='mb-1 mt-2 p-relative'>
                                            <label htmlFor="mobileNumber" className="uname" data-icon="u">Email <span className='star'>*</span></label>
                                            <input
                                                className="field"
                                                placeholder="Enter email for OTP"
                                                name="emailsignup"
                                                type="text"
                                                onChange={(e) => this.onChange(e)}
                                                value={this.state.emailsignup}
                                                disabled={this.state.otpSent > 0}
                                            />
                                            {this.state.emailsignup !== "" && (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim()))) ? <label id='entervalidemaillbl' className="signup-validation-text error-text" style={{ color: "red" }}>Enter Valid Email.</label> : null}

                                            <button className='btn-type-submit otpbtnnew mr-1' disabled={this.validateForSubmit(true)} onClick={() => { this.sendOTP() }} style={{marginTop:"-2px"}}>
                                                {this.state.buttonLoader &&
                                                    <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                                    </svg>}
                                                Get Code
                                            </button>

                                        </div>
                                    }
                                    {/* 30-03-23 STATIC CODE START */}
                                    {/* <div className='mb-1 p-relative'>
                                    <label htmlFor="otpsignup" className="uname" data-icon="u">Enter Code <span className='star'>*</span></label>
                                    <input className="field" type="text" value={this.state.otpsignup} name="otpsignup" maxlength="6" onChange={(e) => this.onChange(e)}onBlur="" placeholder="Enter Code"/>
                                        <button className='btn-type-submit otpbtnnew'> 
                                        { this.state.buttonLoader &&
                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                            </svg>}
                                         Verify Code
                                    </button>
                                </div>
                                <div className='mb-1'>
                                    <label htmlFor="usernamesignup" className="uname" data-icon="u">User ID <span className='star'>*</span></label>
                                    <input className="field" name="usernamesignup" required="required" type="text" onChange={(e) => this.onChange(e)} value={this.state.usernamesignup} onBlur={()=>{this.checkIfUserExists()}} placeholder="User ID"/>
                                    {this.state.usernamesignup !== "" && this.state.usernamesignup.indexOf(' ') > -1 ? <label id='usernospacelbl' className="signup-validation-text error-text" style={{ color: "red" }}>This field cannot have space.</label> : null}
                                    {this.state.usernamesignup !== "" && this.state.usernamesignup.length < 6 ? <label id='userminlengthlbl' className="signup-validation-text error-text" style={{ color: "red" }}>Minimum 6 characters</label> : null}
                                    {this.state.usernamesignup !== "" && this.state.usernamealreadyexist ? <label id='useralreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This Username already exist.</label> : null}
                                </div>
                                <>
                                    <div className='mb-1'>
                                        <label htmlFor="passwordsignup" className="youpasswd" data-icon="p">Password <span className='star'>*</span></label>
                                        <input className="field" id="passwordsignup" name="passwordsignup" required="required" type="password" onChange={(e) => this.onChange(e)} value={this.state.passwordsignup} placeholder="Password" />
                                        <span onClick={() => { this.onPasswodVisible() }} style={{marginTop: "-30px", marginRight: "8px"}} className="float-right">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                        {!!this.state.passwordsignup && 
                                            <>
                                                <ul className='d-flex change-password-valid'>
                                                    <li id="digit" className={this.state.passwordsignup.match(/[0-9]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 digit</li>
                                                    <li id="scharacter" className={this.state.passwordsignup.match(/[a-zA-Z]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 character</li>
                                                    <li id="minlength" className={this.state.passwordsignup.length >= 8 ? "signup-validation-text success-text" : "signup-validation-text"}><i className="fa fa-check"></i> Minimum 8 characters</li>
                                                </ul>
                                                <ul className='change-password-valid'>
                                                    <li id="notuser" className={this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 ? "signup-validation-text error-text" : "d-none"}><i className="fa fa-close"></i> Password can't contain Username</li>
                                                </ul>
                                            </>
                                        }
                                    </div>
                                    <div className='mb-1'>
                                        <label htmlFor="passwordsignup_confirm" className="youpasswd" data-icon="p">Confirm password <span className='star'>*</span></label>
                                        <input className="field" id="passwordsignup_confirm" name="passwordsignup_confirm" required="required" type="password" onChange={(e) => this.onChange(e)} value={this.state.passwordsignup_confirm}  placeholder="Confirm Password"/>
                                        <span onClick={() => { this.onConfirmPasswodVisible() }} style={{marginTop: "-30px", marginRight: "8px"}} className="float-right">{!!this.state.confirmPassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                        {this.state.passwordsignup !== "" && this.state.passwordsignup !== this.state.passwordsignup_confirm ? <label className='signup-validation-text' style={{ color: "red" }}>This field should be same as password.</label> : null}
                                    </div>
                                </>
                                    <div className='mb-1'>
                                        <label htmlFor="signUpReferenceName" className="uname" data-icon="u">Referral code</label>
                                        <input className="field text-transform-uppercase" name="signUpReferenceName" required="required" type="text" onChange={(e) => this.onChange(e)} value={this.state.signUpReferenceName} placeholder="Optional"/>
                                    </div>
                                    <div className="signin mb-1 f11-login">
                                     By clicking on the Register button, you agree to the <a href="#innersection" className='text-blue' onClick={()=>{ this.props.hidePopup(); this.props.toggleSelectedSection("termandconditions")}}>Terms and Conditions</a> and confirm that you are over <strong>18 years old</strong>.
                                </div>
                                    <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={ReCAPTCHA_KEY}
                                /> */}


                                    {/*30-03-23  STATIC CODE END */}
                                    {/* { (ISOTPPASSWORD ? this.state.otpSent > 0 : true) &&  */}
                                    <>
                                        <div className='mb-1'>
                                            <label htmlFor="otpsignup" className="uname" data-icon="u">Enter Code <span className='star'>*</span></label>
                                            <input className="field" type="text" value={this.state.otpsignup} name="otpsignup" maxLength="6" onChange={(e) => this.onChange(e)} disabled={this.state.otpSent === 0} placeholder="Enter OTP" />
                                            {this.state.otpSent !== 0 &&
                                                <>
                                                    {this.state.resendOtp > 0 ?
                                                        <div className='resend-otp' style={{ textDecoration: 'none' }}><a href="#">Resend OTP in {this.state.resendOtp} secs</a></div>
                                                        :
                                                        <div className='resend-otp'><a href="#" className='f-color-white' onClick={() => { this.sendOTP(true) }}>Resend OTP</a></div>
                                                    }
                                                </>
                                            }
                                        </div>

                                        {OTPVia === 'email' &&
                                            <div className="relative">
                                                <label htmlFor="mobileNumber" className="uname" data-icon="u">Mobile</label>
                                                <PhoneInput disabled={this.state.otpSent === 0} specialLabel="" country={'in'} value={this.state.mobileNumber} name="mobileNumber" onChange={(inputNumber, country) => { this.onPhoneNumberChange(inputNumber, country, 'mobileNumber') }} placeholder="Enter Mobile Number" />
                                                {this.state.mobileNumber !== "" && this.state.mobilealreadyexist ? <label id='mobilealreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This mobile number already exists.</label> : null}
                                                {/* <div className=" mt-4 bg-input_darken"> */}
                                                {/* </div> */}
                                            </div>
                                        }

                                        <div className={`mb-1 ${OTPVia === 'email' ? 'mt-2' : ''}`}>
                                            <label htmlFor="usernamesignup" className="uname" data-icon="u">User ID <span className='star'>*</span></label>
                                            <input className="field lowercase" name="usernamesignup" type="text" onChange={(e) => this.onUserChange(e)} value={this.state.usernamesignup} disabled={this.state.otpSent === 0} onBlur={() => { this.checkIfUserExists() }} placeholder="User ID" />
                                            {this.state.usernamesignup !== "" && this.state.usernamesignup.indexOf(' ') > -1 ? <label id='usernospacelbl' className="signup-validation-text error-text" style={{ color: "red" }}>This field cannot have space.</label> : null}
                                            {this.state.usernamesignup !== "" && this.state.usernamesignup.length < 6 ? <label id='userminlengthlbl' className="signup-validation-text error-text" style={{ color: "red" }}>Minimum 6 characters</label> : null}
                                            {this.state.usernamesignup !== "" && this.state.usernamealreadyexist ? <label id='useralreadyexistlbl' className="signup-validation-text error-text" style={{ color: "red" }}>This Username already exist.</label> : null}
                                        </div>

                                        <>
                                            <div className='mb-1'>
                                                <label htmlFor="passwordsignup" className="youpasswd" data-icon="p">Password <span className='star'>*</span> </label>
                                                <input className="field" id="passwordsignup" name="passwordsignup" type="password" onChange={(e) => this.onChange(e)} value={this.state.passwordsignup} disabled={this.state.otpSent === 0} placeholder="Password" />
                                                <span onClick={() => { this.onPasswodVisible() }} style={{ marginTop: "-30px", marginRight: "8px" }} className="float-right">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                                {!!this.state.passwordsignup &&
                                                    <>
                                                        <ul className='d-flex change-password-valid'>
                                                            <li id="digit" className={this.state.passwordsignup.match(/[0-9]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 digit</li>
                                                            <li id="scharacter" className={this.state.passwordsignup.match(/[a-zA-Z]/g) ? "signup-validation-text success-text mr-1" : "signup-validation-text mr-1"}><i className="fa fa-check"></i> At least 1 character</li>
                                                            <li id="minlength" className={this.state.passwordsignup.length >= 8 ? "signup-validation-text success-text" : "signup-validation-text"}><i className="fa fa-check"></i> Minimum 8 characters</li>
                                                        </ul>
                                                        <ul className='change-password-valid'>
                                                            <li id="notuser" className={this.state.passwordsignup.toLowerCase().indexOf(this.state.usernamesignup.toLowerCase()) > -1 ? "signup-validation-text error-text" : "d-none"}><i className="fa fa-close"></i> Password can't contain Username</li>
                                                        </ul>
                                                    </>
                                                }
                                            </div>
                                            <div className='mb-1'>
                                                <label htmlFor="passwordsignup_confirm" className="youpasswd" data-icon="p">Confirm password <span className='star'>*</span></label>
                                                <input className="field" id="passwordsignup_confirm" name="passwordsignup_confirm" type="password" onChange={(e) => this.onChange(e)} value={this.state.passwordsignup_confirm} disabled={this.state.otpSent === 0} placeholder="Confirm Password" />
                                                <span onClick={() => { this.onConfirmPasswodVisible() }} style={{ marginTop: "-30px", marginRight: "8px" }} className="float-right">{!!this.state.confirmPassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                                                {this.state.passwordsignup !== "" && this.state.passwordsignup !== this.state.passwordsignup_confirm ? <label className='signup-validation-text' style={{ color: "red" }}>This field should be same as password.</label> : null}
                                            </div>
                                        </>

                                        {/* <div className='mb-3 d-none'>
                                    <label htmlFor="emailsignup" className="youmail" data-icon="e">Email</label>
                                    <input className="field" name="emailsignup" type="email" onChange={(e) => this.onChange(e)} value={this.state.emailsignup} placeholder="Email Id" />
                                    {(!!this.state.emailsignup.trim() && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailsignup.trim()))) && <label className='signup-validation-text' style={{ color: "red" }}>Enter valid email.</label>}
                                </div> */}

                                        {SHOWSIGNUPREFERENCENAME &&
                                            <>
                                                {/* <div className="signin mb-3">
                                            <input type="checkbox" required="required" name="isSignUpReferenceName" checked={this.state.isSignUpReferenceName} onClick={() => { this.setState({ isSignUpReferenceName: !this.state.isSignUpReferenceName }) }} onChange={(e) => {}}/> Yes!, I have the Referral code.
                                        </div>
                                        {this.state.isSignUpReferenceName && */}
                                                <div className='mb-1'>
                                                    <label htmlFor="signUpReferenceName" className="uname" data-icon="u">Referral code</label>
                                                    <input className="field text-transform-uppercase" name="signUpReferenceName" type="text" onChange={(e) => this.onChange(e)} value={this.state.signUpReferenceName} disabled={!!this.props.affCode || this.state.otpSent === 0} placeholder="Referral Code" />
                                                    {/* {this.state.signUpReferenceName === "" && <label id='usernospacelbl' className="signup-validation-text error-text" style={{ color: "red" }}>This field cannot be blank.</label>} */}
                                                </div>
                                                {/* } */}
                                            </>
                                        }
                                        {/* <div className="signin mb-3">
                                    <input type="checkbox" required="required" name="tncChecked" checked={this.state.tncChecked} onClick={() => { this.setState({ tncChecked: !this.state.tncChecked }) }} onChange={(e) => {}}/> By clicking on the Register button, you agree to the <a href="#innersection" className='text-blue' onClick={()=>{ this.props.hidePopup(); this.props.toggleSelectedSection("termandconditions")}}>Terms and Conditions</a> and confirm that you are over <strong>18 years old</strong>.
                                    {/* <input type="submit" value="Sign up"/> *}
                                </div> */}

                                        <div className="signin mb-1 f11-login">
                                            By clicking on the Register button, you agree to the <a href="#innersection" className='text-blue' onClick={() => { this.props.hidePopup(); this.props.toggleSelectedSection("termandconditions") }}>Terms and Conditions</a> and confirm that you are over <strong>18 years old</strong>.
                                        </div>

                                        {!PotanuCaptcha
                                        &&
                                        <ReCAPTCHA 
                                            size={"invisible"}
                                            ref={recaptchaRef}
                                            sitekey={ReCAPTCHA_KEY}
                                        />
                                        }
                                    </>
                                </div>
                            </div>
                            <div className="modal-footer" id='content1'>
                                <div className="signin button mx-auto">
                                    <button className='btn-type-submit' onClick={() => { this.submitForm() }}>
                                        {this.state.buttonLoader &&
                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                            </svg>}
                                        Register
                                    </button>
                                    {/* { ( ISOTPPASSWORD ? this.state.otpSent === 0 : false)? 
                                    <button className='btn-type-submit' disabled = {this.validateForSubmit(true)} onClick={()=>{this.sendOTP()}}> 
                                        { this.state.buttonLoader &&
                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                            </svg>}
                                        Send OTP
                                    </button>
                                :
                                    <button className='btn-type-submit' disabled = {this.validateForSubmit()} onClick={()=>{this.submitForm()}}> 
                                        { this.state.buttonLoader &&
                                            <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                            </svg>}
                                        Register
                                    </button>
                                } */}
                                    {/* <button className='btn-type-submit' onClick={()=>{this.jointest()}}>
                                        <svg className="spinner" viewBox="0 0 50 50">
                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                                        </svg> 
                                        test
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* <div className="modal-backdrop fade show" onClick={() => { this.props.hidePopup() }}></div> */}
                    < div className="modal-backdrop fade show" ></div >
                </div >
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Joinnowpopup);